import React, { Component } from 'react';
import { connect } from 'react-redux';
import { appActions } from '../../../../store/modules/app';
import { couponActions } from '../../../../store/modules/coupon';
import withModal from '../../../../lib/hoc/withModal';
import ExcelUploadCouponProductValidSuccessModal from '../../../../views/coupon/common/modal/ExcelUploadCouponProductValidSuccessModal';
import { syncProductItemsToZustand } from '../../../../store/couponFormStore';

class ExcelUploadCouponProductValidSuccessModalContainer extends Component {
  /**
   *  업로드하기
   */
  onSubmit = () => {
    const { data, setCouponProductItemListExcelUpload } = this.props;
    const { productList } = data;

    setCouponProductItemListExcelUpload({
      productList,
    });

    syncProductItemsToZustand(productList);

    this.closeModal();
  };

  /**
   *  모달 닫기
   */
  closeModal = () => {
    this.props.toggleModal({
      name: 'excelUploadCouponProductValidSuccessModal',
      value: false,
    });
  };

  render() {
    const { isOpen, data, getProductSubCategoryList } = this.props;

    return (
      <ExcelUploadCouponProductValidSuccessModal
        isOpen={isOpen}
        data={data}
        getProductSubCategoryList={getProductSubCategoryList}
        onSubmit={this.onSubmit}
        closeModal={this.closeModal}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.coupon.excelUploadCouponProductValidSuccessModal.isOpen,
    data: state.coupon.excelUploadCouponProductValidSuccessModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: couponActions.toggleModal,
  setCouponProductItemListExcelUpload: couponActions.setCouponProductItemListExcelUpload,
  getProductSubCategoryList: appActions.getProductSubCategoryList,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withModal()(ExcelUploadCouponProductValidSuccessModalContainer));
